import { TRANSACTION_TYPES } from "store/types";

const initialState = {
  transactions: [],
  totalCount: 0,
  currentPage: 1,
  loading: false,
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRANSACTION_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };

    case TRANSACTION_TYPES.FETCH_TRANSACTIONS_SUCCESS:
      console.log("tras", action.payload);
      return {
        ...state,
        transactions: action.payload.results,
        totalCount: action.payload.count,
        currentPage: action.payload.page,
      };

    default:
      return state;
  }
};

export default transactionReducer;
